import styled from 'styled-components';
import { font, spacing } from '@chegg-ui/theme';
import { Typography } from '@chegg-ui/typography';
import { LinkSC } from "../../common/styles/common.styles";
export var FooterSC = styled(Typography).withConfig({
  componentId: "sc-g0vigs-0"
})(["margin:", " 0 ", " 0;text-align:center;", "{font-size:", ";}"], spacing.px16, spacing.px12, LinkSC, font.size.px12);